export default "__VITE_ASSET__2b7086da__"